import { createSelector } from 'reselect';
import { getVehiclePrefix } from '../../utils/tripUtils';

const EMPTY = [];

function getNestedValue(obj, path) {

    if (!obj || !path) {
        return null;
    }

    if (path === 'PREFIXOVEIC') {
        return getVehiclePrefix(obj.license_plate);
    }

    if (path.includes('.')) {
        return path.split('.').reduce(
            (acc, part) => acc?.[part],
            obj
        );
    }

    return obj[path];
}

const selectHashSource = createSelector(
    [
        state => state.currentHash,
        state => state.availableData,
        state => state.notEscaletedLinesNextData,
        state => state.notEscaletedLinesTodayData,
        state => state.escaletedLinesTodayData,
        state => state.alertN1Data,
        state => state.alertN2Data,
        state => state.alertN3Data
    ],
    (
        currentHash,
        availableData,
        notEscaletedLinesNextData,
        notEscaletedLinesTodayData,
        escaletedLinesTodayData,
        alertN1Data,
        alertN2Data,
        alertN3Data
    ) => {

        switch (currentHash) {

            case 'linhas-disponiveis':
                return availableData;

            case 'linhas-nao-escaladas-amanha':
                return notEscaletedLinesNextData;

            case 'linhas-nao-escaladas-hoje':
                return notEscaletedLinesTodayData;

            case 'viagens-do-dia':
                return escaletedLinesTodayData;

            case 'n1-horapegada':
                return alertN1Data;

            case 'n2-ponto-inicial':
                return alertN2Data;

            case 'n3-tres-primeiros':
                return alertN3Data;

            default:
                return EMPTY;

        }

    }
);

export const selectSortedHashItems = createSelector(
    [
        selectHashSource,
        state => state.order,
        state => state.orderASC,
        state => state.orderTypes
    ],
    (
        hashSource,
        order,
        orderASC,
        orderTypes
    ) => {

        if (!hashSource?.length) {
            return EMPTY;
        }

        const sortConfig = orderTypes.find(
            t => t.id === order
        );

        if (!sortConfig?.primary) {
            return hashSource;
        }

        const compare = (a, b) => {

            let valA = getNestedValue(
                a,
                sortConfig.primary
            );

            let valB = getNestedValue(
                b,
                sortConfig.primary
            );

            if (sortConfig.primary.includes('DATA')) {
                valA = new Date(valA);
                valB = new Date(valB);
            }

            let result = 0;

            if (valA < valB) {
                result = -1;
            } else if (valA > valB) {
                result = 1;
            }

            if (result === 0 && sortConfig.secondary) {

                const secA = String(
                    getNestedValue(a, sortConfig.secondary) ?? ''
                );

                const secB = String(
                    getNestedValue(b, sortConfig.secondary) ?? ''
                );

                result = secA.localeCompare(secB);

            }

            return orderASC ? result : -result;

        };

        return [...hashSource].sort(compare);

    }
);